import { HTTPAPIConfig } from './http-api.config';

export const defaultHTTPConfig: HTTPAPIConfig = {
  method: 'get',
  apiKeyName: 'authenticate',
  postData: {},
  isEntireUrl: false,
  urlString: 'PROJ_API',
  userFieldsToAdd: [],
  routerParamsToAdd: {},
  options: {
    headers: {
      // 'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
      // 'customer-uuid':'5e4e09eb-9200-41c8-95d0-d50655bca07c',
      // 'application-uuid':'c83ca3fb-0ac7-4a0e-a03e-92be37d6c2b9',
      // 'Access-Control-Allow-Credentials': 'true',
      // 'Access-Control-Allow-Headers': 'Content-Type',
      // 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',


    }
  }
};

